var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.0638C0 29.5925 8.53517 38.1277 19.0638 38.1277C29.5925 38.1277 38.1277 29.5925 38.1277 19.0638C38.1277 8.53517 29.5925 0 19.0638 0C8.53517 0 0 8.53517 0 19.0638Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5958 19.0632C28.5958 13.8206 24.3064 9.53125 19.0638 9.53125C13.8213 9.53125 9.53192 13.8206 9.53192 19.0632C9.53192 23.8291 12.9872 27.761 17.5149 28.4759V21.8036H15.1319V19.0632H17.5149V16.9185C17.5149 14.5355 18.9447 13.2249 21.0894 13.2249C22.1617 13.2249 23.234 13.4632 23.234 13.4632V15.8461H22.0426C20.8511 15.8461 20.4936 16.561 20.4936 17.2759V19.0632H23.1149L22.6383 21.8036H20.3745V28.5951C25.1404 27.8802 28.5958 23.8291 28.5958 19.0632Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.101060dec0b84662cef689e4511bf467.svg";
export { ForwardRef as ReactComponent };